import React, { useEffect, useRef, useState } from 'react'

const OTPinput = ({ length = 6, onComplete, reset, className = "" }) => {

    const [otp, setOtp] = useState(Array(length).fill(""));
    const inputRefs = useRef(Array(length).fill(null));

    const handleChange = (index, value) => {
        if (!/^\d*$/.test(value)) return; // Allow only numbers

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input if value is entered
        if (value && index < length - 1) {
            inputRefs.current[index + 1]?.focus();
        }

        // If all inputs are filled, trigger the callback
        if (newOtp.every((digit) => digit !== "")) {
            onComplete(newOtp.join(""));
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, length);

        if (!/^\d+$/.test(pastedData)) {
            // setError('Please paste numbers only'); 

            return;
        }

        const newOtp = [...otp];
        pastedData.split('').forEach((char, index) => {
            if (index < length) {
                newOtp[index] = char;
            }
        });
        setOtp(newOtp);
        if (newOtp.every((digit) => digit !== "")) {
            onComplete(newOtp.join(""));
        }



        const nextEmptyIndex = newOtp.findIndex(val => !val);
        if (nextEmptyIndex !== -1) {
            inputRefs.current[nextEmptyIndex]?.focus();
        } else {
            inputRefs.current[length - 1]?.focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    useEffect(() => {
        if (reset) {
            setOtp(Array(length).fill(""));
            // inputRefs.current[0]?.focus(); // Focus on the first input 
        }
        inputRefs.current[0]?.focus();
    }, [reset, length]);
    // useEffect(() => {
    //     inputRefs.current[0]?.focus(); // Focus the first input on mount
    // }, []);

    return (
        <section className="py-3 ">
            <div className="flex justify-center gap-2">
                {otp.map((value, index) => (
                    <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        maxLength={1}
                        value={value}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onPaste={handlePaste}
                        className={`w-12 h-12 font-semibold text-center border border-gray-300 rounded-md focus:border-blue-500 focus:outline-none ${className}`}
                    />
                ))}
            </div>
        </section>
    )
}

export default OTPinput